import canadian from '@svg/flags/canadian.svg';

export const currencies = {
    CAD: {
        icon: canadian,
        symbol: '$'
    }
};
